export const SET_SPLASH_SCREEN_STATE = 'SET_SPLASH_SCREEN_STATE'